import { RoadStructuresShedsAttributeConvert } from "@/attribute/convert/RoadStructuresShedsAttributeConvert";
import { FeatureType } from "../define/FeatureType";
import { AbstractRoadStructuresLayerFactory } from "./AbstractRoadStructuresLayerFactory";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";

/**
 * 点検データ(シェッド)レイヤ 出力クラス
 */
export class RoadStructuresShedsLayerFactory extends AbstractRoadStructuresLayerFactory {
  /**
   * API取得用URL
   */

  URL_API = process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL + "/sheds";

  /**
   * アイコンURL
   */

  URL_LAYER_ICON = "./icon/layer/structures-sheds.png";

  /**
   * アイコンのサイズ
   */

  ICON_SIZE = 1;

  /**
   * 最大ズームレベル
   */

  LAYER_MAX_ZOOMLEVEL = 18;

  /**
   * 最小ズームレベル
   */

  LAYER_MIN_ZOOMLEVEL = 11;

  /**
   * コンテキストメニュー名称
   */
  CONTEXT_MENU_NAME = "点検DB_シェッド";

  /**
   * 対象データ出力レイヤ
   */
  FEATURE_TYPE = FeatureType.Sheds;

  /**
   * 対象Attribute変換クラス
   */
  ATTRIBUTE_CONVERT = (geoJSON: any) =>
    new RoadStructuresShedsAttributeConvert(geoJSON) as IAttributeConvert;
}
